var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloudMessage = function SvgCloudMessage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.506 0C5.60981 0 0 4.46087 0 9.94037C0.0245943 11.3066 0.365602 12.6493 0.997119 13.8666C1.62864 15.0838 2.53405 16.1436 3.64459 16.9654C3.72557 17.2991 3.73821 17.6454 3.68176 17.984C3.62532 18.3227 3.50093 18.6469 3.31583 18.9378C3.13073 19.2287 2.88862 19.4805 2.60358 19.6786C2.31855 19.8766 1.99629 20.017 1.65555 20.0915C1.51883 20.1197 1.39657 20.1943 1.31015 20.3022C1.21417 20.4255 1.15086 20.5703 1.12591 20.7236C1.10097 20.8768 1.11516 21.0338 1.16722 21.1804C1.26569 21.382 1.41679 21.5543 1.6051 21.6797C1.79341 21.8052 2.0122 21.8793 2.23916 21.8946C2.65199 21.9664 3.07053 22.0016 3.48976 21.9999C5.69945 21.8999 7.80488 21.0472 9.44497 19.588C10.4485 19.7889 11.4699 19.8909 12.494 19.8924C19.3902 19.8924 25 15.4316 25 9.95208C25 4.47258 19.4021 0 12.506 0Z",
    fill: "#4B97E9"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud_message.ab0a6221.svg";
export { ForwardRef as ReactComponent };